<template>
    <div>
      <utility-list-link ref="utilityListLink" :listLayout="listLayout" :utilityData="List" :paginationData="filterSet.page"></utility-list-link>
      <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
import PaginationLink from "@/components/utility/PaginationLink.vue";
import utilityUtil from "@/components/utility/utilityUtil";
import UtilityListLink from "@/components/utility/UtilityListLink.vue";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import util from '@/mixins/util'

const {filterConfig} = utilityUtil;

export default {
  name: "UtilityTransactionListComponent",
  mixins: [utilityUtil, filterMixins, listMixins, alertMixins],
  components: {PaginationLink, UtilityListLink},
  inject: [],
  provide() {
    return {
      setPage: this.setPage,
      setFilter: this.setFilter,
    }
  },
  props: {
    utilityType: {
      default: () => {
      }
    },
    utilKey: {default: 0},
    userKey: {default: 0},
  },
  data() {
    return {
      listLayout: '',
      paginationLayout: '',
      getFunc: '',
      listApiParamSet: {},
      pageRow: 10,
      paginationType:'',
      keyName: '',
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initConfig();
    this.setFilterConfig(filterConfig)
    this.setParserType('url', this.$route.fullPath);
  },
  mounted() {
    this.getDataList(true);
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    initConfig() {
      let config = this.returnUtilityConfig(this.utilityType);
      this.listLayout= config.listLayout;
      this.paginationLayout = config.paginationLayout;
      this.getFunc = config.getFunc;
      this.listApiParamSet = config.listApiParamSet;
      this.paginationType =config.paginationType;
      this.keyName = config.keyName;

      if (config.pageRow && config.pageRow != this.filterSet.page.size) {
        this.pageRow = config.pageRow;
        this.filterSet.page.size = config.pageRow;
        this.pageClass.setterPage('size', this.pageRow);
      }

      let params = JSON.parse(JSON.stringify(this.listApiParamSet));
      if (!util.isEmpty(this.utilKey)) {
        params[this.keyName] = this.utilKey
      }
      let listOptions = {
        url : this.$api.$utility[this.getFunc],
        defaultParams : params
      }
      this.initList('api', listOptions);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
